module.exports = new __parcel__URL__("page.cc74cd19.gif").toString();